import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

export default function Navbar() {
  const location = useLocation()
  const isActive = (path) => location.pathname === path
  const [mobileOpen, setMobileOpen] = useState(false)

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/metodo', label: 'Il Metodo' },
    { to: '/nerd-power', label: 'Nerd Power' },
    { to: '/about', label: 'Chi è Amedeo' },
    { to: '/libro', label: 'Il Libro' },
    { to: '/blog', label: 'Blog' },
  ]

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 px-4 py-3"
      style={{
        background: 'rgba(5,5,16,0.85)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(139,92,246,0.1)',
      }}
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center" onClick={() => setMobileOpen(false)}>
          <img 
            src="/logo-text-only.png" 
            alt="Nerd Coach Logo" 
            className="h-20 md:h-24 w-auto object-contain transition-transform duration-300 hover:scale-105" 
          />
        </Link>

        {/* Desktop menu */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`text-xs font-display uppercase tracking-wider transition-colors ${
                isActive(to) ? 'text-nerd-cyan' : 'text-nerd-gray hover:text-nerd-cyan'
              }`}
            >
              {label}
            </Link>
          ))}
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Menu"
        >
          <span
            className="block w-5 h-0.5 bg-nerd-gray transition-all duration-300"
            style={{ transform: mobileOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none' }}
          />
          <span
            className="block w-5 h-0.5 bg-nerd-gray transition-all duration-300"
            style={{ opacity: mobileOpen ? 0 : 1 }}
          />
          <span
            className="block w-5 h-0.5 bg-nerd-gray transition-all duration-300"
            style={{ transform: mobileOpen ? 'rotate(-45deg) translate(4px, -4px)' : 'none' }}
          />
        </button>
      </div>

      {/* Mobile dropdown */}
      {mobileOpen && (
        <div
          className="md:hidden mt-2 pb-4 border-t flex flex-col gap-4 pt-4 px-2"
          style={{ borderColor: 'rgba(139,92,246,0.15)' }}
        >
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`text-sm font-display uppercase tracking-wider transition-colors ${
                isActive(to) ? 'text-nerd-cyan' : 'text-nerd-gray'
              }`}
              onClick={() => setMobileOpen(false)}
            >
              {label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  )
}
